import { z } from "zod";
var CalloutType = /* @__PURE__ */ ((CalloutType2) => {
  CalloutType2["Neutral"] = "neutral";
  CalloutType2["Success"] = "success";
  CalloutType2["Danger"] = "danger";
  CalloutType2["Warning"] = "warning";
  CalloutType2["Info"] = "info";
  return CalloutType2;
})(CalloutType || {});
const normalizeCalloutType = (type) => {
  const lowerType = type.toLowerCase();
  const aliases = {
    "warn": "warning" /* Warning */,
    "warning": "warning" /* Warning */,
    "info": "info" /* Info */,
    "information": "info" /* Info */,
    "neutral": "neutral" /* Neutral */,
    "success": "success" /* Success */,
    "danger": "danger" /* Danger */
  };
  if (aliases[lowerType]) {
    return aliases[lowerType];
  }
  const validTypes = Object.values(CalloutType);
  const foundType = validTypes.find((validType) => validType === type);
  return foundType || "neutral" /* Neutral */;
};
const attributesCalloutSchema = z.object({
  type: z.string().transform(normalizeCalloutType),
  isEditable: z.boolean().optional(),
  icon: z.string().optional()
});
export {
  CalloutType,
  attributesCalloutSchema,
  normalizeCalloutType
};
//# sourceMappingURL=attributes.js.map
